import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import {
  Upload,
  ChevronLeft,
  ChevronRight,
  Check,
  Delete,
} from 'sushiweb/Icons';
import { Button } from '@grofers/react';
import { Upload as uploadSvg } from '../../../images/svg';
import { black, green, white } from 'sushiweb/tokens/color';
import { Loader } from '../../../UiKit';
import { useUploadFile } from './uploadComplaintMedia';
import {
  DeleteComplaintMediaInModalEvent,
  UploadComplaintMediaClickEvent,
} from '../../../analytics/raise-an-issue/events';
import { MetricsForJumboEvent } from '../../../analytics/constants';

export const mediaTypes = {
  image: 'IMAGE',
  video: 'VIDEO',
};

export const mediaValidationSlugs = {
  not_applicable: 'NOT_APPLICABLE',
  applicable: 'APPLICABLE',
  mandatory: 'MANDATORY',
};

export const UploadMediaComp = ({
  updateImageGrid,
  textToShow,
  textStyle,
  orderId,
  userId,
  cartId = null,
  sessionId,
  isUploadEnabled,
  isInputDisabled = false,
  fromModal = false,
  onClick = null,
  icon = null,
  keyVal = null,
  complaintType = null,
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const { mutate } = useUploadFile(updateImageGrid, setIsUploading);

  const onChange = (e) => {
    e.preventDefault();
    setIsUploading(true);

    const formData = new FormData();
    let files = e.target.files;
    if (files?.length) setIsUploading(true);
    for (let i = 0; i < files.length; i++) {
      formData.append(`media_files-${i}`, files[i]);
    }
    formData.append('order_id', orderId);
    formData.append('customer_id', userId);
    if (window.dashboard.mode != 'lifelineZ' && sessionId)
      formData.append('session_id', sessionId);
    mutate(formData);
  };

  return (
    <form>
      <input
        type='file'
        name='media_files'
        id={`uploadInput_${textToShow}_${keyVal}`}
        onChange={onChange}
        multiple
        className='tw-hidden'
        accept='image/*'
        disabled={isInputDisabled || !isUploadEnabled}
      />
      <label
        className='uploadBtnBox'
        htmlFor={`uploadInput_${textToShow}_${keyVal}`}
      >
        <span
          className={`uploadBtn tw-flex tw-items-center tw-justify-center tw-cursor-pointer  tw-py-1  tw-rounded-lg  ${
            isUploadEnabled
              ? !fromModal
                ? 'tw-bg-green-700 tw-text-white tw-px-3'
                : 'tw-text-green-700'
              : !fromModal
              ? 'tw-bg-grey-300 tw-text-white tw-px-3'
              : 'tw-text-green-700'
          }`}
          onClick={
            textToShow === 'Upload' && isUploadEnabled
              ? () => {
                  UploadComplaintMediaClickEvent({
                    [MetricsForJumboEvent.order_id]: orderId,
                    [MetricsForJumboEvent.cart_id]: cartId,
                    [MetricsForJumboEvent.customer_id]: userId,
                    [MetricsForJumboEvent.feature_meta]: {
                      complaint_type: complaintType,
                    },
                  });
                }
              : onClick
              ? onClick
              : null
          }
        >
          {icon}
          <span className={`${textStyle}`}>
            {isUploading ? 'Uploading...' : textToShow}
          </span>
        </span>
      </label>
    </form>
  );
};

export const ComplaintMediaComp = ({
  availableComplaintImages,
  handleIssueImageModal,
  updateImageGrid,
  orderId,
  userId,
  cartId,
  sessionId,
  deleteComplaintImages,
  mediaRrefetching,
  complaintType = null,
}) => {
  const [customerUploadedMedia, setCustomerUploadedMedia] = useState([]);
  const [agentUploadedImages, setAgentUploadedImages] = useState([]);
  const [showLeftArrowCx, setShowLeftArrowCx] = useState(false);
  const [showRightArrowCx, setShowRightArrowCx] = useState(true);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [confirmDelete, setConfirmDelete] = useState({});
  const prevAgentImagesRef = useRef();

  useEffect(() => {
    const scroller1 = document.getElementById('x-scroll-1');
    const scroller2 = document.getElementById('x-scroll-2');
    if (scroller1) {
      scroller1.scrollLeft = 0;
      setShowLeftArrowCx(false);
      if (scroller1.scrollWidth - scroller1.clientWidth > 0)
        setShowRightArrowCx(true);
      else setShowRightArrowCx(false);
    }
    if (scroller2) {
      scroller2.scrollLeft = 0;
      setShowLeftArrow(false);
      if (scroller2.scrollWidth - scroller2.clientWidth > 0)
        setShowRightArrow(true);
      else setShowRightArrow(false);
    }
  }, [availableComplaintImages, agentUploadedImages, customerUploadedMedia]);

  useEffect(() => {
    const complaintImages = availableComplaintImages;

    let cxMedia = [],
      agentMedia = [];
    for (let i = 0; i < complaintImages.length; i++) {
      if (complaintImages[i].media_source === 'lifeline')
        agentMedia.push(complaintImages[i]);
      else cxMedia.push(complaintImages[i]);
    }
    setCustomerUploadedMedia(cxMedia);
    setAgentUploadedImages(agentMedia);
  }, [availableComplaintImages]);

  useEffect(() => {
    const isChanged =
      prevAgentImagesRef.current?.length != agentUploadedImages?.length;
    const scroller2 = document.getElementById('x-scroll-2');
    if (scroller2 && isChanged && prevAgentImagesRef.current?.length != 0) {
      scroller2.scrollLeft = scroller2.scrollWidth - scroller2.clientWidth;
      setShowRightArrow(false);
      if (scroller2.scrollWidth - scroller2.clientWidth > 0)
        setShowLeftArrow(true);
      else setShowLeftArrow(false);
    }
    prevAgentImagesRef.current = agentUploadedImages;
  }, [agentUploadedImages.length]);

  useEffect(() => {
    if (confirmDelete?.success) {
      const ind = confirmDelete?.index;
      let updatedImgs = [];
      agentUploadedImages.splice(ind, 1);
      updatedImgs = [...agentUploadedImages];
      setAgentUploadedImages(updatedImgs);
    }
  }, [confirmDelete]);

  const handleLeftArrowCx = () => {
    if (!showLeftArrowCx) return;
    const element = document.getElementById('x-scroll-1');
    sideScroll(
      element,
      'left',
      20,
      450,
      30,
      setShowLeftArrowCx,
      setShowRightArrowCx,
    );
  };

  const handleRightArrowCx = () => {
    if (!showRightArrowCx) return;
    const element = document.getElementById('x-scroll-1');
    sideScroll(
      element,
      'right',
      20,
      450,
      30,
      setShowLeftArrowCx,
      setShowRightArrowCx,
    );
  };

  const handleLeftArrowAg = () => {
    if (!showLeftArrow) return;
    const element = document.getElementById('x-scroll-2');
    sideScroll(
      element,
      'left',
      20,
      450,
      30,
      setShowLeftArrow,
      setShowRightArrow,
    );
  };

  const handleRightArrowAg = () => {
    if (!showRightArrow) return;
    const element = document.getElementById('x-scroll-2');
    sideScroll(
      element,
      'right',
      20,
      450,
      30,
      setShowLeftArrow,
      setShowRightArrow,
    );
  };

  if (mediaRrefetching)
    return (
      <div
        className='tw-w-full  tw-flex tw-items-center tw-justify-center'
        style={{ minHeight: '45vh' }}
      >
        <Loader />
      </div>
    );

  return (
    <div className='tw-flex-col tw-w-full tw-gap-6  '>
      <div className='tw-flex-col  tw-w-full tw-border-solid tw-border-grey-200 tw-rounded-xl tw-px-8 tw-mb-7 tw-pt-5 tw-relative '>
        <div className='tw-flex tw-gap-2 tw-text-400 tw-font-semibold tw-text-grey-700 tw-items-center tw-justify-between'>
          <div className='tw-flex tw-gap-2 tw-items-center tw-justify-center'>
            <span className='tw-bg-green-700 tw-rounded-full tw-w-6 tw-h-6 tw-items-center tw-justify-center'>
              <Check
                size={14}
                color={white}
                className='tw-relative tw-top-[0.9px]'
              />
            </span>
            <span>Customer Uploaded Images and Videos</span>
          </div>
        </div>
        {customerUploadedMedia?.length ? (
          <div
            className='tw-flex tw-gap-4 tw-w-full  tw-overflow-x-scroll tw-items-center '
            id='x-scroll-1'
            css={`
              ::-webkit-scrollbar {
                display: none;
              }
            `}
          >
            <div
              className={`tw-flex tw-items-start tw-justify-center tw-rounded-full tw-ml-5 tw-absolute tw-left-0 ${
                showLeftArrowCx
                  ? 'tw-bg-grey-700 tw-cursor-pointer'
                  : 'tw-bg-grey-200 tw-cursor-not-allowed'
              }`}
              css={`
                & i {
                  position: relative;
                  left: -1px;
                }
              `}
              onClick={handleLeftArrowCx}
            >
              <ChevronLeft size={25} color={white} />
            </div>
            {customerUploadedMedia.map((media) => {
              return (
                <div className='tw-flex tw-items-center tw-justify-center tw-py-5 tw-px-0  tw-gap-3 tw-w-64 '>
                  <div className='tw-gap-3 tw-w-64 tw-h-64'>
                    {media?.media_type === mediaTypes['image'] ? (
                      <img
                        src={media?.media_url}
                        width='100%'
                        height='100%'
                        className='tw-rounded-xl tw-border-solid tw-border-grey-200'
                      />
                    ) : (
                      <div className='tw-w-64 tw-h-64'>
                        <video
                          src={media?.media_url}
                          width='100%'
                          height='100%'
                          controls
                          autoPlay
                          muted
                          className='tw-rounded-xl tw-border-solid tw-border-grey-200'
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
            <div
              className={`tw-flex tw-items-start tw-justify-center tw-rounded-full tw-mr-5 tw-absolute tw-right-0 ${
                showRightArrowCx
                  ? 'tw-bg-grey-700 tw-cursor-pointer'
                  : 'tw-bg-grey-200 tw-cursor-not-allowed'
              }`}
              css={`
                & i {
                  position: relative;
                  right: -1px;
                }
              `}
              onClick={handleRightArrowCx}
            >
              <ChevronRight size={25} color={white} />
            </div>
          </div>
        ) : (
          <div className='tw-w-full tw-flex tw-items-center tw-justify-center tw-text-grey-700 tw-text-300 tw-font-medium'>
            <div className='tw-w-full tw-bg-indigo-100 tw-py-4 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-mb-8 tw-mt-8'>
              <div className='tw-text-grey-600 tw-text-300 tw-font-medium tw-w-full tw-flex tw-items-center tw-px-6 tw-justify-center'>
                Customer has not uploaded any image. Ask him to upload or upload
                it yourself.
              </div>
            </div>
          </div>
        )}
      </div>

      <div className='tw-flex-col  tw-w-full tw-border-solid tw-border-grey-200 tw-rounded-xl tw-px-8 tw-mb-7 tw-pt-5 tw-relative '>
        <div className='tw-flex tw-gap-2 tw-text-400 tw-font-semibold tw-text-grey-700 tw-items-center tw-justify-between'>
          <div className='tw-flex tw-gap-2 tw-items-center tw-justify-center'>
            <span className='tw-bg-green-700 tw-rounded-full tw-w-6 tw-h-6 tw-items-center tw-justify-center'>
              <Check
                size={14}
                color={white}
                className='tw-relative tw-top-[0.9px]'
              />
            </span>
            <span>Uploaded By Agents</span>
          </div>
          {agentUploadedImages?.length ? (
            <div className='tw-flex tw-gap-5 tw-text-green-700'>
              <div className='tw-py-2 tw-px-4 tw-rounded-xl tw-border tw-border-solid tw-border-grey-300  tw-text-200 tw-font-semibold tw-cursor-pointer tw-flex tw-gap-1'>
                <UploadMediaComp
                  fromModal
                  isInputDisabled={false}
                  isUploadEnabled={true}
                  updateImageGrid={updateImageGrid}
                  textToShow='Upload'
                  textStyle='tw-text-200 tw-font-semibold tw-px-2'
                  orderId={orderId}
                  userId={userId}
                  sessionId={sessionId}
                  icon={<Upload size={13} color={green.z700} />}
                  keyVal='1'
                  complaintType={complaintType}
                  cartId={cartId}
                />
              </div>
            </div>
          ) : null}
        </div>

        {agentUploadedImages?.length ? (
          <div
            className='tw-flex tw-gap-4 tw-w-full  tw-overflow-x-scroll tw-items-center '
            id='x-scroll-2'
            css={`
              ::-webkit-scrollbar {
                display: none;
              }
            `}
          >
            <div
              className={`tw-flex tw-items-start tw-justify-center tw-rounded-full tw-ml-5 tw-absolute tw-left-0 tw-z-30 ${
                showLeftArrow
                  ? 'tw-bg-grey-700 tw-cursor-pointer'
                  : 'tw-bg-grey-200 tw-cursor-not-allowed'
              }`}
              css={`
                & i {
                  position: relative;
                  left: -1px;
                }
              `}
              onClick={handleLeftArrowAg}
            >
              <ChevronLeft size={25} color={white} />
            </div>
            {agentUploadedImages.map((media, index) => {
              return (
                <div className='tw-flex tw-items-center tw-justify-center tw-py-5 tw-px-0  tw-gap-3 tw-w-64 '>
                  <div className='tw-gap-3 tw-w-64 tw-h-64 tw-relative'>
                    {media?.media_type === mediaTypes['image'] ? (
                      <img
                        src={media?.media_url}
                        width='100%'
                        height='100%'
                        className='tw-rounded-xl tw-border-solid tw-border-grey-200'
                      />
                    ) : (
                      <div className='tw-w-64 tw-h-64'>
                        <video
                          src={media?.media_url}
                          width='100%'
                          height='100%'
                          controls
                          autoPlay
                          muted
                          className='tw-rounded-xl tw-border-solid tw-border-grey-200'
                        />
                      </div>
                    )}
                    {media?.can_delete && (
                      <div
                        className='tw-absolute tw-top-2 tw-left-2 tw-bg-white tw-rounded-full tw-p-2 tw-border-solid tw-border-grey-300 tw-cursor-pointer'
                        onClick={() => {
                          DeleteComplaintMediaInModalEvent({
                            [MetricsForJumboEvent.order_id]: orderId,
                            [MetricsForJumboEvent.cart_id]: cartId,
                            [MetricsForJumboEvent.customer_id]: userId,
                            [MetricsForJumboEvent.feature_meta]: {
                              complaint_type: complaintType,
                              media_id: media?.media_id,
                            },
                          });
                          deleteComplaintImages(
                            media?.media_id,
                            setConfirmDelete,
                            index,
                          );
                          setConfirmDelete({
                            isDeleting: true,
                            mediaId: media?.media_id,
                          });
                        }}
                      >
                        {confirmDelete?.isDeleting &&
                        confirmDelete?.mediaId === media?.media_id ? (
                          <div className='tw-flex tw-items-center tw-justify-center'>
                            <Loader size='small' />
                          </div>
                        ) : (
                          <Delete size={15} color={black} />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
            <div
              className={`tw-flex tw-items-start tw-justify-center tw-rounded-full tw-mr-5 tw-absolute tw-right-0 ${
                showRightArrow
                  ? 'tw-bg-grey-700 tw-cursor-pointer'
                  : 'tw-bg-grey-200 tw-cursor-not-allowed'
              }`}
              css={`
                & i {
                  position: relative;
                  right: -1px;
                }
              `}
              onClick={handleRightArrowAg}
            >
              <ChevronRight size={25} color={white} />
            </div>
          </div>
        ) : (
          <div className='tw-w-full tw-flex-col tw-gap-5 tw-items-center tw-justify-center'>
            <div>
              <span className='tw-flex tw-items-center tw-justify-center tw-w-full tw-mb-5'>
                {uploadSvg}
              </span>
              <span className='tw-text-300 tw-font-semibold tw-text-grey-700 tw-flex tw-items-center tw-justify-center tw-w-full '>
                Upload More Images
              </span>
            </div>
            <div className='tw-mt-5 tw-mx-auto tw-w-32 tw-mb-5 '>
              <UploadMediaComp
                fromModal={false}
                isInputDisabled={false}
                isUploadEnabled={true}
                updateImageGrid={updateImageGrid}
                textToShow='Upload'
                textStyle='tw-text-100 tw-font-medium tw-px-3 tw-py-2'
                orderId={orderId}
                userId={userId}
                sessionId={sessionId}
                keyVal='2'
                complaintType={complaintType}
                cartId={cartId}
              />
            </div>
          </div>
        )}
      </div>
      <div className='tw-flex tw-items-center tw-justify-end  tw-text-white '>
        <Button
          variant={'fill'}
          className='tw-h-16 tw-w-64 tw-rounded-xl'
          onClick={handleIssueImageModal}
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export const sideScroll = (
  element,
  direction,
  speed,
  distance,
  step,
  setLeftArrowFunc,
  setRightArrowFunc,
) => {
  let scrollAmount = 0;
  var slideTimer = setInterval(function () {
    handleArrowActivity(
      element,
      direction,
      step,
      setLeftArrowFunc,
      setRightArrowFunc,
    );
    scrollAmount += step;
    if (scrollAmount >= distance) {
      window.clearInterval(slideTimer);
      if (direction === 'left') {
        setRightArrowFunc(true);
      } else {
        setLeftArrowFunc(true);
      }
    }
  }, speed);
};

export const handleArrowActivity = (
  element,
  direction,
  step,
  setLeftArrowFunc,
  setRightArrowFunc,
) => {
  if (element.scrollLeft - step <= 0) setLeftArrowFunc(false);
  if (element.scrollLeft + step >= element.scrollWidth - element.clientWidth)
    setRightArrowFunc(false);
  if (direction == 'left') element.scrollLeft -= step;
  else element.scrollLeft += step;
};
